import { useEffect, useState } from "react";

const useForceStateUpdate = () => {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // edit state to force render
  // An function that increment 👆🏻 the previous state like here
  // is better than directly setting `value + 1`
};

export const useForceUpdateWithParams = (valuesToWatch: []) => {
  const forceUpdateState = useForceStateUpdate();

  useEffect(() => {
    forceUpdateState();
  }, valuesToWatch);
};

export const useForceUpdate = () => {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // edit state to force render
  // An function that increment 👆🏻 the previous state like here
  // is better than directly setting `value + 1`
};
